// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { px } from '../tokens/conversions';
import { palette } from '../tokens/palette';
import { borderRadius, pageBreakpoints, spacing } from '../tokens/spacing';
import { typography } from '../tokens/typography';
import { getComponentOverrides } from './getComponentOverrides';
var borderRadiusPx = {
    default: px(borderRadius.default),
    small: px(borderRadius.small),
    tiny: px(borderRadius.tiny),
    none: px(borderRadius.none)
};
/**
 * Creates a theme option based on the mode passed in
 * @param mode either light / dark
 * @returns a theme option passed to createTheme
 */ export var createThemeOption = function(mode) {
    var themeOption = {
        name: 'aurora-design-system',
        palette: _object_spread({
            mode: mode
        }, palette[mode]),
        typography: typography,
        breakpoints: {
            values: _object_spread({}, pageBreakpoints)
        },
        spacing: 4,
        themeSpacing: spacing,
        borderRadius: borderRadiusPx,
        shape: {
            borderRadius: borderRadius.default
        },
        components: getComponentOverrides(mode)
    };
    return themeOption;
};

//# sourceMappingURL=createThemeOption.js.map